function text(value) {
  return String(value == null ? '' : value).trim();
}
function bool(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

function firstText(...values) {
  return values.map(text).find(Boolean) || null;
}

function timestamp(value) {
  if (value && typeof value.toMillis === 'function') return value.toMillis();
  if (value && typeof value.toDate === 'function') return value.toDate().getTime();
  const parsed = new Date(value || 0).getTime();
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function resolveEntryType(record) {
  const explicit = text(record.meldingEntryType || record.entryType || record.meldingType || record.type).toLowerCase();
  if (['automatic', 'automatisch', 'auto', 'email_intake'].includes(explicit)) return 'AUTOMATIC';
  if (['human', 'handmatig', 'manual'].includes(explicit)) return 'HUMAN';
  const source = text(record.source || record.sourceType).toLowerCase();
  return bool(record.isAutoMelding)
    || ['vestiging_auto', 'myrobot_email', 'email_intake'].includes(source)
    ? 'AUTOMATIC'
    : 'HUMAN';
}

export function normalizeCanonicalEvent(record = {}, fallback = {}) {
  const entryType = resolveEntryType(record);
  const eventTimestamp = timestamp(record.timestamp || record.createdAt || record.updatedAt || record.datum || fallback.timestamp);
  const visit = bool(record.isVisit)
    || bool(record.isRobotBezocht)
    || bool(record.robotBezocht)
    || bool(record.visit)
    || text(record.eventType).toLowerCase() === 'visit';
  const maintenance = bool(record.isMaintenance)
    || bool(record.maintenance)
    || text(record.category || record.eventType).toLowerCase().includes('maintenance');
  const blade = bool(record.isBladeRelated)
    || bool(record.bladeRelated)
    || record.bladeHeads != null
    || record.bladesPerHead != null
    || record.mesjes != null
    || record.totalMesjesUsed != null;
  const branchId = firstText(record.branchId, record.vestigingId, record.vestiging, record.branchName, fallback.branchId);
  const robotSerial = firstText(record.robotSerial, record.serialNumber, record.serial, record.robotId, fallback.robotSerial);
  const source = firstText(record.source, record.sourceType, entryType === 'AUTOMATIC' ? 'automatic' : 'human');

  return {
    eventId: firstText(record.eventId, record.id, record.docId, record.meldingId, fallback.eventId),
    branchId,
    robotSerial,
    timestamp: eventTimestamp ? new Date(eventTimestamp).toISOString() : null,
    entryType,
    isHuman: entryType === 'HUMAN',
    isAutomatic: entryType === 'AUTOMATIC',
    isVisit: visit,
    isMaintenance: maintenance,
    isBladeRelated: blade,
    source,
    raw: record,
  };
}

export function canonicalEventMatchesScope(event, scope = 'ALL') {
  const normalized = text(scope).toUpperCase();
  if (normalized === 'HUMAN') return event?.isHuman === true;
  if (normalized === 'AUTOMATIC' || normalized === 'AUTO') return event?.isAutomatic === true;
  if (normalized === 'VISITS') return event?.isVisit === true;
  if (normalized === 'MAINTENANCE') return event?.isMaintenance === true;
  if (normalized === 'BLADE') return event?.isBladeRelated === true;
  return true;
}
